<template>
  <ModelEditFormPriceAgreement
    class="model-edit-form-project-rental-dispense-item"
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="project"
    @input="wasChanged = true"
  />
</template>

<script setup lang="ts">
import ModelEditFormPriceAgreement from "@/components/model_edit_form/ModelEditFormPriceAgreement.vue"
import { Project } from "@/models/project.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import { inject } from "vue"
import { useProjectsRentalDispenseItemsStore } from "@/store/projects-rental-dispense-items.store"
import { ProjectRentalDispenseItem } from "@/models/project-rental-dispense-item.model"
import type { RentalDispenseItem } from "@/models/rental-dispense-item.model"

const props = defineProps<{
  project: Project
  rentalDispenseItem: RentalDispenseItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<RentalDispenseItem, ProjectRentalDispenseItem>(
    props.project,
    props.rentalDispenseItem,
    useProjectsRentalDispenseItemsStore(),
    inject("projectRentalDispenseItemController")!,
    ProjectRentalDispenseItem
  )

defineExpose({ savePriceAgreement })
</script>

<style scoped></style>
